import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  CustomSoftIcon,
  SoftwareProIcon,
  SoftwareMainIcon,
} from "../../../app-constants";
import { Link } from "gatsby"; // Import Gatsby's Link component
import HtmlParser from "react-html-parser";

const StackItem = [
  {
    icon: CustomSoftIcon,
    title: "Custom Software Development",
    description:
      "Custom-made software solutions developed to meet your exclusive business requirements, guaranteeing ideal functionality and competence. With TekRevol, your software development plans will flourish with the abundance of expert knowledge and resources.",
  },
  {
    icon: SoftwareProIcon,
    title: "Software Product Development",
    description:
      "State-of-the-art and scalable software product development, bringing market success through innovative and cutting-edge technology. TekRevol develops scalable and resilient SaaS, Mobile, and desktop software products with unmatched UX.",
  },
  {
    icon: SoftwareMainIcon,
    title: "Software Support & Maintenance",
    description:
      "Consistent support and maintenance services, ensuring the effortless operation and durability of your software products. We guarantee smooth operations and relevancy of your software through non-stop performance monitoring, optimization, new features, and issue resolution.",
  },
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description: (
      <>
        'Enhance{" "}
        <Link to="/android-app-development">Android App development</Link>{" "}
        experience with TekRevol, and maximize the potential of the world\'s
        most widely used platform with native apps. With the help of a dynamic
        tech stack of Java or Kotlin, we breathe life into your app concepts
        with accuracy and innovation.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "iPhone App Development",
    description: (
      <>
        Enrich your iOS applications with TekRevol's ,{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iPhone App Development services
        </Link>{" "}
        providing sophisticated, seamless functional native apps. We pay careful
        attention to every aspect, guaranteeing your app aligns effortlessly
        with Apple's design philosophies and guidelines.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description: (
      <>
        Enter the lucrative gaming industry with TekRevol’s{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          mobile game development
        </Link>{" "}
        with extremely immersive and monetization-ready games for your business.
        Capable in multiple genres such as shooting, arcade, RPG, and strategy,
        we can create any kind of game you visualize.
      </>
    ),
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              TekRevol’s Custom App & Software Development Services in Chicago
            </h2>
            <p className="impro_para">
              Experience revolutionary innovation with TekRevol's customized
              software and app solutions, developed to change your digital
              existence. Empower your business with front-line technology and
              creativity, generating unmatched growth and success. We are your
              one-stop software development solution, and we promise you to
              propel your business to unprecedented heights.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
